export class TransInquiryTrustFields {
    trustIncomePercent: string;
    trustPrincipalPercent: string;
    trustTaxCode: string;
    trustPaidFor: string;
    trustIncomeToPercent: string;
    trustPrincipalToPercent: string;
    trustTaxCategory: string;
    trustComment: string;
    trustDepositCode: string;
}